module.exports = __webpack_public_path__ + "static/img/serve6.b23f1e29.png";